import { Component, EventEmitter, Input } from '@angular/core';

@Component({
    selector: 'app-dynamic-link',
    template: `<a (click)="redirect.emit()" style="text-decoration: none; color: inherit; font-weight: bold" [routerLink]="path">{{text}}</a>`,
    standalone: false
})
export class DynamicLinkComponent {
  @Input() path: string;
  @Input() text: string;
  @Input() redirect: EventEmitter<void>;
}
